import { render } from "./NovedadesAjustes.vue?vue&type=template&id=6846fa58"
import script from "./NovedadesAjustes.vue?vue&type=script&lang=js"
export * from "./NovedadesAjustes.vue?vue&type=script&lang=js"

import "./NovedadesAjustes.vue?vue&type=style&index=0&id=6846fa58&lang=css"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__